<template>
  <div class="game-offer-gold container">
    <div class="game-offer-gold__head">
      <h2 class="game-offer-gold__title">
        Select your region, faction, and server
      </h2>

      <div class="game-offer-gold__filters">
        <switcher-tabs
          :tabs="regions"
          :value="activeRegionIndex"
          mode="default"
          class="game-offer-gold__switcher"
          @input="setRegion" />

        <switcher-tabs
          :tabs="currentNameFactions"
          :value="activeFactionIndex"
          mode="default"
          class="game-offer-gold__switcher"
          @input="setFactions" />

        <search-input
          v-model="searchServer"
          placeholder="Choose your server"
          :search-results="serversList"
          is-data-list-mode
          class="game-offer-gold__search" />
      </div>
    </div>

    <ul class="game-offer-gold__list">
      <game-offer-gold-item-old
        v-for="item in currentItems"
        :key="`${activeRegion.id}-${item.id}-${item._faction.id}`"
        :server="item"
        class="game-offer-gold__item"
        @select-server="openGoldPopup" />
    </ul>

    <ui-pagination
      v-if="totalItems > itemsPerPage"
      v-model="page"
      :total="totalItems"
      :items-per-page="itemsPerPage"
      class="game-offer-gold__pagination" />

    <!-- static content -->
    <how-it-works
      :titles="howItWorksContent"
      class="game-gold-offer__how" />

    <product-description
      :product="product"
      :show-navigation="false"
      :reviews-slider-props="reviewsSliderProps"
      class="game-gold-offer__description" />

    <!--    <product-faq
      :items="faqContent"
      class="game-gold-offer__faq" />-->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import GameModel from 'Models/GameModel';
import FactionModel from 'Models/FactionModel';
import RegionModel from 'Models/RegionModel';
import { ServerModel, ServerPopularityModel } from 'Models/WowModel';
import { WowWotlkModel } from 'Models/WowWotlkModel';
import yandexMetrika from 'Root/drivers/yandexMetrika';
import googleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import UiPagination from 'Components/ui/Pagination/UiPagination.vue';
import SwitcherTabs from 'Components/ui/Tabs/SwitcherTabs.vue';
import SearchInput from 'Components/ui/Input/SearchInput.vue';
import GameOfferGoldItemOld from 'Root/pages/game/gameOffer/GameOfferGoldItemOld.vue';
import GoldDetailsPopupOld from 'Root/pages/game/components/GoldDetailsPopupOld.vue';
import { ServerWowClassicModel } from 'Models/WowClassicModel';
import HowItWorks from 'Root/pages/game/components/HowItWorks.vue';
import ProductDescription from 'Root/pages/game/components/ProductDescription.vue';
// import ProductFaq from 'Root/pages/game/components/ProductFaq.vue';
import PaymentSystemModel from 'Models/PaymentSystemModel';
import tiktokTagAnalytics from 'Root/drivers/tiktokTagAnalytics';

/* TODO: Warning! Удалить компонент после тестов валюты на проде SKY-3296 */
export default {
  name: 'GameOfferGold',

  components: {
    GameOfferGoldItemOld,
    SwitcherTabs,
    UiPagination,
    SearchInput,
    HowItWorks,
    ProductDescription,
    // ProductFaq,
  },

  props: {
    isSplitView: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      page: 1,
      itemsPerPage: 20,
      servers: [],
      serversList: [],
      stripe: null,
      stripePaymentRequest: null,
      availableStripePaymentMethods: {
        googlePay: false,
      },

      /* Filter */
      factionId: FactionModel.HORDE.id,
      searchServer: '',

      /* static */
      howItWorksContent: [
        'Choose the amount of Gold',
        'Fill in your details',
        'Make a payment',
        'Completes delivery within delivery guarantee',
        'Confirm delivery',
      ],

      // faqContent: [
      //   {
      //     // eslint-disable-next-line max-len
      //     title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore quibusdam tenetur possimus aliquid qui, expedita nostrum ullam impedit maiores explicabo? ',
      //     // eslint-disable-next-line max-len
      //     text: 'After the warranty period (10 days) expires, money for the completed order is transferred from your hold balance to the main one. You can withdraw funds from the main account: use the Withdrawal form, in the Dashboard or Balance section',
      //   },
      //   {
      //     title: 'After the warranty period expires?',
      //     // eslint-disable-next-line max-len
      //     text: 'After the warranty period (10 days) expires, money for the completed order is transferred from your hold balance to the main one. You can withdraw funds from the main account: use the Withdrawal form, in the Dashboard or Balance section',
      //   },
      //   {
      //     title: 'After the warranty period expires?',
      //     // eslint-disable-next-line max-len
      //     text: 'After the warranty period (10 days) expires, money for the completed order is transferred from your hold balance to the main one. You can withdraw funds from the main account: use the Withdrawal form, in the Dashboard or Balance section',
      //   },
      //   {
      //     title: 'After the warranty period expires?',
      //     // eslint-disable-next-line max-len
      //     text: 'After the warranty period (10 days) expires, money for the completed order is transferred from your hold balance to the main one. You can withdraw funds from the main account: use the Withdrawal form, in the Dashboard or Balance section',
      //   },
      // ],

      reviewsSliderProps: {
        perView: 4,
        breakpoints: {
          1700: {
            perView: 3,
          },
        },
      },
    };
  },

  computed: {
    ...mapState(['activeRegion', 'userDevice', 'countryCode']),
    ...mapState('products', ['product', 'tags']),

    isMobile() {
      return this.userDevice.innerWidth < 610;
    },

    regions() {
      return RegionModel.LIST;
    },

    activeRegionIndex() {
      return this.regions.findIndex((region) => region.id === this.activeRegion.id);
    },

    activeFactionIndex() {
      return FactionModel.LIST.findIndex((factions) => factions.id === this.factionId);
    },

    currentNameFactions() {
      return FactionModel.LIST.reverse();
    },

    serverModel() {
      if (+this.product.game === GameModel.WOW.id) {
        if (process.env.WOW_CLASSIC_GOLD_OFFER && this.product.id === +process.env.WOW_CLASSIC_GOLD_OFFER) {
          return {
            all: ServerWowClassicModel[this.activeRegion.id],
            popularity: null,
          };
        }

        return {
          all: ServerModel[this.activeRegion.id],
          popularity: ServerPopularityModel[this.activeRegion.id],
        };
      }

      return {
        all: WowWotlkModel[this.activeRegion.id],
        popularity: null,
      };
    },

    filteredList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.page = 1;
      let filteredServersList = this.servers;

      filteredServersList = filteredServersList.filter(
        (server) => !server._faction || server._faction.id === this.factionId,
      );

      if (this.searchServer.length) {
        filteredServersList = filteredServersList.filter((server) => server.title.includes(this.searchServer));
      }

      return filteredServersList;
    },

    currentItems() {
      return this.filteredList.slice((this.page - 1) * this.itemsPerPage, this.page * this.itemsPerPage);
    },

    totalItems() {
      return this.filteredList.length;
    },
  },

  watch: {
    activeRegion() {
      this.setServers();

      this.page = 1;
    },

    isMobile() {
      this.page = 1;
    },

    product() {
      this.setServers();
    },
  },

  created() {
    this.setServers();
    if (typeof window !== 'undefined') {
      this.sendAnalytics();
    }
  },

  mounted() {
    if (window.Stripe) {
      this.checkStripeAvailableMethods();
    } else {
      const stripeScript = document.getElementById('stripe-script');
      if (!stripeScript) {
        return;
      }

      stripeScript.onload = () => {
        this.checkStripeAvailableMethods();
      };
    }
  },

  methods: {
    ...mapMutations(['mutateActiveRegion']),

    parsePriceToStripeAmount(price) {
      let amount = 0;

      if (String(price).includes('.')) {
        const splittedPrice = String(price).split('.');
        amount = Number(splittedPrice[0]) * 100 + Number(splittedPrice[1]);
      } else {
        amount = price * 100;
      }

      return +amount;
    },

    async checkStripeAvailableMethods() {
      this.stripe = window.Stripe(PaymentSystemModel.STRIPE_PUBLIC_KEY);

      const country = this.countryCode;
      const currency = this.activeRegion.currency.title.toLowerCase();

      if (!country) {
        return;
      }

      this.stripePaymentRequest = this.stripe.paymentRequest({
        country,
        currency,
        /**
         * {@link https://stripe.com/docs/js/appendix/payment_item_object}
         */
        total: {
          label: this.product?.title,
          amount: this.parsePriceToStripeAmount(10),
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      let canMakePaymentVia = null;

      try {
        canMakePaymentVia = await this.stripePaymentRequest.canMakePayment();
        // eslint-disable-next-line no-empty
      } catch (e) {}

      if (canMakePaymentVia) {
        if (Object.keys(canMakePaymentVia).includes('googlePay')) {
          this.availableStripePaymentMethods.googlePay = true;
        }
      }
    },

    setServers() {
      // при SPA переходе в продукте нет ренжа
      // в таком случае ждём когда он появится и тогда уже делаем setServers (см. watch product)
      if (!this.product.meta.range) {
        return;
      }

      this.servers = [];
      this.serversList = [];

      const defaultRange = this.product.meta.range;

      this.product.meta.servers[this.activeRegion.id].forEach((serverData) => {
        const wowServer = this.serverModel.all.find((server) => server.id === serverData.id);

        FactionModel.LIST.forEach((faction) => {
          const factionGoldInfo = serverData?.goldInfo?.[faction.id];
          const deliveryTime = factionGoldInfo?.deliveryTime && factionGoldInfo?.deliveryTime !== '0'
            ? factionGoldInfo.deliveryTime
            : '1 hour';

          const newServer = {
            ...wowServer,
            ...serverData,
            _faction: FactionModel.ID_TO_DATA[faction.id],
            _deliveryTimeFormatted: deliveryTime,
          };

          newServer.range = serverData.range?.[faction.id] ? serverData.range[faction.id] : defaultRange;

          this.servers.push(newServer);
        });
      });

      if (this.serverModel.popularity) {
        this.servers.sort((a, b) => {
          const aPopularity = this.serverModel.popularity.indexOf(a.title);
          const bPopularity = this.serverModel.popularity.indexOf(b.title);

          return (aPopularity > -1 ? aPopularity : Infinity) < (bPopularity > -1 ? bPopularity : Infinity) ? -1 : 1;
        });
      }

      this.servers.forEach((server, index) => {
        if (index % 2 === 0) {
          return;
        }

        this.serversList.push(server.title);
      });
    },

    setFactions(index) {
      this.factionId = FactionModel.LIST[index].id;
    },

    setRegion(index) {
      if (index === this.activeRegionIndex) {
        return;
      }

      this.searchServer = '';
      const currentRegion = this.regions[index];
      this.mutateActiveRegion(currentRegion.id);
      this.$cookie.set(RegionModel.REGION_COOKIE, currentRegion.id, { expires: '5Y' });
      localStorage.setItem(RegionModel.REGION_COOKIE, currentRegion.id);
      googleTagAnalytics.emitSelectRegion(currentRegion.shortTitle);
    },

    openGoldPopup(server) {
      this.$vuedals.openMobilePanel({
        name: 'gold-details-popup',
        class: 'gold-detail-bg',
        component: GoldDetailsPopupOld,
        data: {
          product: this.product,
          server,
          stripeData: {
            stripe: this.stripe,
            stripePaymentRequest: this.stripePaymentRequest,
            availableStripePaymentMethods: this.availableStripePaymentMethods,
            parsePriceToStripeAmount: this.parsePriceToStripeAmount,
          },
          isSplitView: this.isSplitView,
        },
      });

      googleTagAnalytics.fireBuyClick('buy_now_1', this.product.title);
      tiktokTagAnalytics.fireAddToCart(this.user, this.price, this.activeRegion.currency.title);
    },

    sendAnalytics() {
      const productTag = this.tags.find((tag) => tag.id === this.product.master_tag_id);
      googleTagAnalytics.firePageView(this.product, productTag, this.product.cost_usa);
      tiktokTagAnalytics.fireViewContent(this.user);

      if (this.isSplitView) {
        googleTagAnalytics.fireGtagEvent('view', 'split_marketplace_purchase_control', null);
        yandexMetrika.invokeEvent('split_marketplace_page_view_control');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.game-offer-gold {
  display: grid;
  grid-gap: 16px;
  position: relative;
  z-index: 2;
}

.game-offer-gold__head {
  display: grid;
  grid-gap: 16px;
}

.game-offer-gold__title {
  font-size: 17px;
  font-weight: 500;
}

.game-offer-gold__filters {
  display: grid;
  grid-gap: 16px 8px;
  grid-template-columns: max-content 1fr;
}

.game-offer-gold__switcher {
  --font-size: 13px;
  --background-color: #{$color--basic-blue};
  --container-padding: 5px;
  --button-padding: 6px 8px;
}

.game-offer-gold__search {
  --font-size: 13px;
  --height: auto;
  --input-padding: 10px;
  --border-radius: 4px !important;
  --input-bg-color: #{rgba($color--basic-blue, 0.25)};
  --elements-background-color: #29335a;
  --background-color--focused: #29335a;

  font-size: 13px;

  /deep/ {
    .ui-input__wrap-inner {
      border: 2px solid rgba($color--basic-blue, 0.25);
    }

    .ui-input__wrap {
      --placeholder-color: #{$color--basic-white};
    }

    .search-input__arrow {
      --shape-color: currentColor;
    }
  }
}

.game-offer-gold__list {
  --columns: auto-fit;

  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(var(--columns, auto-fit), minmax(280px, 1fr));
}

.game-offer-gold__item {
  cursor: pointer;
}

.game-offer-gold__pagination {
  margin-top: 16px;
}

.game-gold-offer__how {
  /* TODO: fix */
  --steps-template-columns: repeat(5, minmax(0, 1fr)) !important;

  margin-bottom: 20px;
}

/deep/ .game-gold-offer__description {
  overflow: hidden;

  .product-description__item {
    padding: 0;
  }
}

@media only screen and (max-width: 639.2px) {
  .game-offer-gold__search {
    grid-column: 1 / -1;
  }
}

@media only screen and #{$screen-more-or-640} {
  .game-offer-gold__filters {
    grid-gap: 16px;
    grid-template-columns: max-content max-content 1fr;
  }
}

@media only screen and #{$screen-more-or-1024} {
  .game-offer-gold {
    grid-gap: 40px;
    margin-bottom: 40px;
  }

  .game-offer-gold__head {
    grid-gap: 24px;
  }

  .game-offer-gold__title {
    font-size: 25px;
  }

  .game-offer-gold__list {
    --columns: 1;
  }

  .game-offer-gold__switcher {
    --font-size: 15px;
  }

  .game-offer-gold__search {
    --font-size: 15px;
    --input-padding: 12px;
  }

  .game-gold-offer__how {
    margin-bottom: 40px;
  }
}

@media only screen and #{$screen-more-or-1280} {
  .game-offer-gold__head {
    padding-right: $game-header-gold-logo-width-more-of-1280;
  }
}
</style>
